import React from 'react'
import { cn } from '@s4l/utility-css'

import { Text } from './Text'
import { Animation } from './Animation'

import styles from './index.module.css'

export interface IPlaceholderProps {
  width?: string
  height?: string
  rounded?: boolean
  className?: string
}

function Placeholder(props: IPlaceholderProps) {
  const { width, height, rounded = false, className = '' } = props

  return (
    <div
      className={cn(styles.placeholder, className, { [styles.rounded]: rounded })}
      style={{ width, height }}
      data-testid="placeholder"
    />
  )
}
Placeholder.displayName = 'Placeholder'

Placeholder.Text = Text
Placeholder.Animation = Animation

export default Placeholder
